import { render, staticRenderFns } from "./LectureEnrollmentForUsers.vue?vue&type=template&id=494d22fa&"
import script from "./LectureEnrollmentForUsers.vue?vue&type=script&lang=ts&"
export * from "./LectureEnrollmentForUsers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports